import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "downloadDiv" ]

  connect() {
  }

  downloadEnabledSelected(event) {
    if ($(event.target).val() == "true") {
      $(this.downloadDivTarget).removeClass("d-none")
    } else {
      $(this.downloadDivTarget).addClass("d-none")
    }
  }
}
